import { render, staticRenderFns } from "./XPosSettings.vue?vue&type=template&id=50e8d33a&scoped=true"
import script from "./XPosSettings.vue?vue&type=script&lang=js"
export * from "./XPosSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e8d33a",
  null
  
)

export default component.exports